const Z_INDEX = {
  PAGE_HEADER: 3,
  NAVIGATION: 2,
  OVERLAY: 1
}

export default Z_INDEX
